import { render, staticRenderFns } from "./SelectedImagesDialog.vue?vue&type=template&id=fa4df798&scoped=true"
import script from "./SelectedImagesDialog.vue?vue&type=script&lang=ts"
export * from "./SelectedImagesDialog.vue?vue&type=script&lang=ts"
import style0 from "./SelectedImagesDialog.vue?vue&type=style&index=0&id=fa4df798&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4df798",
  null
  
)

export default component.exports